var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBubble6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 428,
    height: 84,
    viewBox: "0 0 428 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.713 -95.779C194.649 -57.6095 160.358 35.0479 217 96C268.881 151.828 361.785 137.661 399.298 204.003C442.615 280.609 436.808 395.666 373.35 456.64C310.112 517.403 207.727 482.622 120.713 471.684C48.9153 462.659 -19.3441 445.853 -75.5017 400.217C-139.276 348.392 -204.035 286.047 -208.687 204.003C-213.505 119.03 -162.037 41.4839 -99.0919 -15.8015C-39.1477 -70.3559 48.6912 -132.96 120.713 -95.779Z",
    fill: "url(#paint0_linear_1301_52)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1301_52",
    x1: -209,
    y1: 192.263,
    x2: 427.254,
    y2: 192.263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B4397"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.807292,
    stopColor: "#DC2430"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E0000",
    stopOpacity: 0.9
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubble6);
export default __webpack_public_path__ + "static/media/bubble_6.99f8c7fe43f70f771eb6d14f8c032988.svg";
export { ForwardRef as ReactComponent };